/**
 * LAUTARO CUSTOMIZATIONS - Cart Account Synchronization
 * Ensures cart is properly tied to user account when logged in
 * Shopify automatically merges carts when users log in, but this adds extra functionality
 */

(function() {
  'use strict';

  // Monitor login state changes
  function initCartAccountSync() {
    // Check if user just logged in (by checking for customer and fresh session)
    const urlParams = new URLSearchParams(window.location.search);
    const justLoggedIn = urlParams.get('customer_posted') === 'true' || 
                         urlParams.get('auto_redirect') === '1';
    
    if (justLoggedIn && typeof Shopify !== 'undefined' && Shopify.customer) {
      console.log('User logged in - Cart will be synced to account');
      
      // Shopify automatically syncs cart on login, but we can add a confirmation
      // Show brief notification that cart is tied to account
      showCartSyncNotification();
    }
  }

  // Show notification that cart is tied to account
  function showCartSyncNotification() {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #4CAF50;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 9998;
      animation: slideIn 0.3s ease-out;
      max-width: 300px;
    `;
    
    notification.innerHTML = `
      <style>
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideOut {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(400px);
            opacity: 0;
          }
        }
      </style>
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <svg style="width: 20px; height: 20px;" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <span style="font-weight: 500;">Your cart is now saved to your account</span>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease-out';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Ensure cart items persist across sessions for logged-in users
  function ensureCartPersistence() {
    if (typeof Shopify === 'undefined' || !Shopify.customer) {
      return;
    }

    // Add event listener for when user adds items to cart
    document.addEventListener('cart:updated', function(event) {
      console.log('Cart updated for logged-in user - Shopify will persist to account');
    });

    // Monitor cart changes through mutation observer
    const cartIcon = document.querySelector('[href*="/cart"]');
    if (cartIcon) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            console.log('Cart badge updated - changes saved to account');
          }
        });
      });

      observer.observe(cartIcon, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCartAccountSync();
      ensureCartPersistence();
    });
  } else {
    initCartAccountSync();
    ensureCartPersistence();
  }
})();
